<template>
    <div class="distribution-chart mx-auto mb-5" style="width: 50%"></div>
</template>

<script>

import 'apexcharts/dist/apexcharts.css'
import ApexCharts from 'apexcharts'
import ChartLabels from './ChartLabels'
import ChartColors from './ChartColors'

export default {
    props: {
        data: {
            type: Array,
            required: true,
        },
        factor: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            default: () => 'Distribution'
        }
    },
    data() {
        return {
            chart: null,
            labels: ChartLabels,
            colors: ChartColors['all']            
        }
    },
    watch: {
        factor() {
            const model = this.buildModel(this.factor)
            this.chart.updateSeries(model.series)
            this.chart.updateOptions({labels: model.labels, colors: ChartColors[this.factor]})
        },
        title(text) {
            this.chart.updateOptions({title: {text: text}})
        }
    },
    mounted() {
        const model = this.buildModel(this.factor)
        this.chart = new ApexCharts(this.$el, {
            chart: {
                type: 'donut',
                toolbar: {
                    // https://apexcharts.com/docs/options/chart/toolbar/
                    show: false,
                    tools: {
                        download: false,
                        zoom: true,
                    },
                    export: {
                        svg: {
                            filename: 'TRAFIG-indicators.svg'
                        }
                    }
                },    
            },
            // colors: ['#D7263D', '#1B998B', '#2E294E', '#F46036', '#E2C044', '#775DD0'],
            colors: ['#4C5358', '#007396', '#E75112', '#70A4BB', '#F29C68', '#B8BEC2'],
            theme: {
                mode: 'light',
                // palette: 'palette7',
            },
            title: {
                text: this.title,
                align: 'center',
                style: {
                    fontSize: '1.5rem',
                    fontFamily: '"Roboto sans", sans',
                    fontWeight: 500,
                },
                offsetY: 15,
            },
            legend: {
                show: true,
                position: 'bottom',
            },
            dataLabels: {
                enabled: true
            },
            labels: model.labels,
            series: model.series,
        })
        this.chart.render()
    },
    unmounted() {
        this.chart.destroy()
        delete this.chart
    },
    methods: {

        buildModel(factor) {

            const counts = {}
            for (const record of this.data) {
                const key = (factor == 'all') ? factor : record[factor]
                if (key === '..' || key === '#NULL!') {
                    continue
                }
                if (!(key in counts)) {
                    counts[key] = 0
                }
                counts[key]++
            }

            const model = {
                labels: [],
                series: []
            }

            for (const key in counts) {
                model.labels.push(ChartLabels[factor][key] ?? key)
                model.series.push(counts[key])
            }

            return model
        }
    } 
}
</script>